<template>
  <div
    class="AppBarDocumentSearchSnippet text-grey-800 text--small"
    :class="`AppBarDocumentSearchSnippet--${variant}`"
    v-html="joinedSnippets"
    data-locator="document-search-snippet"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'

const { highlights, variant = 'menu' } = defineProps<{
  highlights: string[]
  variant?: 'menu' | 'page'
}>()

const MAX_LINES = 2

const joinedSnippets = computed(() =>
  highlights.map(s => s.replace(/\n+/g, ' ').trim()).join('... '),
)
</script>

<style lang="scss">
.AppBarDocumentSearchSnippet {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: v-bind(MAX_LINES);
  line-clamp: v-bind(MAX_LINES);
  text-overflow: ellipsis;
  overflow: hidden;

  em {
    font-style: normal;
    font-weight: 600;
  }

  &--page em {
    background: linear-gradient(
      to bottom,
      rgb(var(--v-theme-yellow-lighten-4)) 85%,
      rgb(var(--v-theme-yellow-300)) 95%
    );
    border-radius: 2px;
    padding: 0.1em 0;
  }
}
</style>
